import api from "api";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { Lesson } from "routes/createContent/views/lessons/LessonPreview";

const useGetLesson = (lesson_id?: number, locale?: string) => {
  const queryParams = new URLSearchParams();
  if (locale) {
    queryParams.set("locale", locale);
  }
  const qs = queryParams.toString();
  const path = qs ? `GET /lessons/${lesson_id}?${qs}` : `GET /lessons/${lesson_id}`;

  return useQuery<Lesson>(
    queryKeys.getLesson(lesson_id, locale),
    () =>
      // @ts-ignore
      api.parse(path, {
        root: process.env.REACT_APP_API_URL_V2 + "/v2/support",
      }),
    {
      enabled: !!lesson_id,
    }
  );
};

export default useGetLesson;
